import { create } from 'zustand';
import type { OrderRecord } from '@adiox/api';
import type { Position } from '../../stream/accountModel';

export type OrderWindowContext =
  | { kind: 'position'; row: Position }
  | { kind: 'order'; row: OrderRecord }
  /** A blank ticket, not tied to any existing position or order (opened from New Order / F9). */
  | { kind: 'new' };

interface OrderWindowState {
  context: OrderWindowContext | null;
  open: (context: OrderWindowContext) => void;
  close: () => void;
}

/**
 * Triggers the classic terminal's rich Order window from anywhere — a Trade-table row's double-click, or the
 * New Order button / F9, which open it blank. `ClassicTradeTable` renders the window itself and reads this store,
 * so New Order works whenever the Trade tab is open (the window isn't mounted standalone).
 */
export const useOrderWindow = create<OrderWindowState>((set) => ({
  context: null,
  open: (context) => set({ context }),
  close: () => set({ context: null }),
}));
